@if (header(); as header) {
  <div
    class="website-nav"
    [class.theme-dark]="isDarkChrome()"
    [class.theme-light]="!isDarkChrome()"
    [class.scrolled]="pill()"
    [class.menu-surface]="menuSurface()"
    [class.menu-open]="menuOpen()"
    [class.menu-from-top]="menuFromTop()"
  >
    <div class="website-nav-shell">
      <!-- Mobile: pill morphs open (skeleton — menu content intentionally omitted) -->
      <nav class="header header-mobile hide-on-non-mobile" aria-label="Primary">
        <div class="header-mobile-top">
          <div class="header-logo header-logo-closed">
            <a class="logo-el" [routerLink]="['/'] | translateLink">
              <ng-container *ngTemplateOutlet="picflowLogoMark"></ng-container>
              <span class="logo-wordmark">Picflow</span>
            </a>
          </div>

          @if (menuSurface()) {
            <a
              class="menu-open-logo"
              [routerLink]="['/'] | translateLink"
              (click)="closeMobileMenu()"
              aria-label="Picflow home"
            >
              <ng-container *ngTemplateOutlet="menuOpenLogoMark"></ng-container>
            </a>
          }

          <div class="header-buttons header-buttons-closed">
            <ng-container *ngTemplateOutlet="ctaButtons"></ng-container>
            @if (!hideNav()) {
              <button
                appButton
                shape="round"
                name="mobile-menu"
                location="website-header"
                [attr.aria-label]="menuOpen() ? 'Close menu' : 'Open menu'"
                [attr.aria-expanded]="menuOpen()"
                [iconButton]="true"
                color="hard-simple"
                (click)="menuOpen() ? closeMobileMenu() : openMobileMenu()"
                height="1"
              >
                <span class="menu-icon" aria-hidden="true">
                  <span></span>
                  <span></span>
                </span>
                <div class="button-hitbox-extender"></div>
              </button>
            }
          </div>
        </div>

        <div
          class="mobile-menu-panel"
          [attr.aria-hidden]="menuOpen() ? null : 'true'"
          [attr.inert]="menuOpen() ? null : ''"
        >
          <div class="mobile-menu-panel-inner">
            <div class="mobile-menu-panel-content">
              <div class="mobile-menu-nav">
                @for (item of header.menu; track item.text) {
                  @if (item.component === 'menu_item') {
                    <a
                      class="mobile-menu-toplevel style-text-strong"
                      appButton
                      name="{{ item.text | lowercase | replace: ' ' : '-' }}"
                      location="website-mobile-menu"
                      color="simple"
                      weight="bold"
                      [routerLink]="[item.link | storyblokLink]"
                      (click)="closeMobileMenu()"
                    >
                      <span>{{ item.text }}</span>
                      <svg
                        class="custom-svg mobile-menu-chevron chevron-link"
                        viewBox="0 0 16 16"
                        width="16"
                        height="16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M11 6.5L8 9.5L5 6.5"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  } @else {
                    <div class="mobile-menu-accordion" [class.acc-open]="openAccordion() === item.text">
                      <button
                        class="mobile-menu-toplevel style-text-strong"
                        appButton
                        name="{{ item.text | lowercase | replace: ' ' : '-' }}"
                        location="website-mobile-menu"
                        color="simple"
                        weight="bold"
                        [attr.aria-expanded]="openAccordion() === item.text"
                        (click)="toggleAccordion(item.text)"
                      >
                        <span>{{ item.text }}</span>
                        <svg
                          class="custom-svg mobile-menu-chevron"
                          viewBox="0 0 16 16"
                          width="16"
                          height="16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M11 6.5L8 9.5L5 6.5"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>

                      <div
                        class="mobile-menu-accordion-panel"
                        [attr.aria-hidden]="openAccordion() === item.text ? null : 'true'"
                        [attr.inert]="openAccordion() === item.text ? null : ''"
                      >
                        <div class="mobile-menu-accordion-inner">
                          @for (subItem of item.buttons; track subItem.text) {
                            @if (subItem.link.linktype === 'story') {
                              <a
                                class="mobile-menu-subitem"
                                [routerLink]="[subItem.link | storyblokLink]"
                                (click)="closeMobileMenu()"
                              >
                                <span class="mobile-menu-icon-tile">
                                  <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                                </span>
                                <span class="mobile-menu-subitem-copy">
                                  <span class="mobile-menu-subitem-text style-text-strong">{{ subItem.text }}</span>
                                  @if (subItem.description) {
                                    <span class="mobile-menu-subitem-desc style-text-muted">{{
                                      subItem.description
                                    }}</span>
                                  }
                                </span>
                              </a>
                            } @else {
                              <a
                                class="mobile-menu-subitem"
                                [href]="subItem.link.url"
                                target="_blank"
                                (click)="closeMobileMenu()"
                              >
                                <span class="mobile-menu-icon-tile">
                                  <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                                </span>
                                <span class="mobile-menu-subitem-copy">
                                  <span class="mobile-menu-subitem-text style-text-strong">{{ subItem.text }}</span>
                                  @if (subItem.description) {
                                    <span class="mobile-menu-subitem-desc style-text-muted">{{
                                      subItem.description
                                    }}</span>
                                  }
                                </span>
                              </a>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>

            <div class="mobile-menu-footer">
              @if (!loggedIn()) {
                <a
                  appButton
                  name="login"
                  location="website-mobile-menu"
                  routerLink="/auth/login"
                  spacing="full"
                  (click)="closeMobileMenu()"
                  weight="bold"
                  shape="round"
                >
                  {{ 'Log in' | translate: 'website-header.login' }}
                </a>
                <a
                  appButton
                  name="signup"
                  location="website-mobile-menu"
                  routerLink="/auth/signup"
                  spacing="full"
                  (click)="closeMobileMenu()"
                  color="primary"
                  shape="round"
                  weight="bold"
                >
                  {{ 'Try for Free' | translate: 'website-header.try-for-free' }}
                </a>
              } @else {
                <a
                  appButton
                  name="dashboard"
                  location="website-mobile-menu"
                  routerLink="/auth/login"
                  spacing="full"
                  (click)="closeMobileMenu()"
                  color="primary"
                  shape="round"
                  weight="bold"
                  [hasIcon]="true"
                >
                  <span>{{ 'Dashboard' | translate: 'website-header.dashboard' }}</span>
                  <app-svg src="/assets/icons/chevron-right.svg"></app-svg>
                </a>
              }
            </div>
          </div>
        </div>
      </nav>

      <!-- Desktop -->
      <nav class="header hide-on-mobile" aria-label="Primary">
        <div class="header-logo">
          <a class="logo-el" [routerLink]="['/'] | translateLink">
            <ng-container *ngTemplateOutlet="picflowLogoMark"></ng-container>
            <span>Picflow</span>
          </a>
        </div>
        <div class="spacer"></div>

        @if (!hideNav()) {
          <app-website-desktop-menu [menuStructure]="header.menu"></app-website-desktop-menu>
        }
        <div class="spacer"></div>
        <div class="header-buttons">
          <ng-container *ngTemplateOutlet="ctaButtons"></ng-container>
        </div>
      </nav>
    </div>
  </div>
}

<!-- Inline chrome SVGs: no mask-image fetch / no CDN (see docs/SVG-MASKING.md). -->
<ng-template #picflowLogoMark>
  <svg
    class="logo-symbol"
    viewBox="0 0 32 32"
    width="32"
    height="32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 2C6.58172 2 3 5.58172 3 10H19V2H11ZM21 28C25.4183 28 29 24.4183 29 20H13V28H21ZM21 2C25.4183 2 29 5.58172 29 10V18H21V2ZM11 12H3V30L11 28V12Z"
      fill="currentColor"
    />
  </svg>
</ng-template>

<!-- Split into one path per logo element so each can fade + jitter on open. -->
<ng-template #menuOpenLogoMark>
  <svg
    class="menu-open-logo-symbol"
    viewBox="0 0 32 32"
    width="48"
    height="48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path class="element-1" d="M11 2C6.58172 2 3 5.58172 3 10H19V2H11Z" fill="currentColor" />
    <path class="element-2" d="M21 2C25.4183 2 29 5.58172 29 10V18H21V2Z" fill="currentColor" />
    <path class="element-3" d="M21 28C25.4183 28 29 24.4183 29 20H13V28H21Z" fill="currentColor" />
    <path class="element-4" d="M11 12H3V30L11 28V12Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #ctaButtons>
  @if (!customCta()) {
    <div class="hide-on-non-mobile">
      <a
        [routerLink]="'/auth/signup'"
        appButton
        shape="round"
        name="signup"
        location="website-header"
        color="primary"
        weight="bold"
        class="above-other-hitboxes"
        height="1"
        size="1"
      >
        {{ 'Try for Free' | translate: 'website-header.try-for-free' }}
      </a>
    </div>
    <div class="flex hide-on-mobile">
      @if (!loggedIn()) {
        @if (!hideNav()) {
          <a
            class="nav-login"
            [routerLink]="'/auth/login'"
            appButton
            shape="round"
            name="login"
            location="website-header"
            weight="bold"
            color="simple-gray"
          >
            {{ 'Log in' | translate: 'website-header.login' }}
          </a>
        }
        <a
          [routerLink]="'/auth/signup'"
          appButton
          shape="round"
          name="signup"
          location="website-header"
          color="primary"
          weight="bold"
          spacing="3"
        >
          {{ 'Try for Free' | translate: 'website-header.try-for-free' }}
        </a>
      } @else {
        <a
          [routerLink]="'/auth/login'"
          appButton
          shape="round"
          name="dashboard"
          location="website-header"
          weight="bold"
          color="primary"
          [hasIcon]="true"
        >
          <span>{{ 'Dashboard' | translate: 'website-header.dashboard' }}</span>
          <app-svg src="/assets/icons/chevron-right.svg"></app-svg>
        </a>
      }
    </div>
  }
  @if (customCta() === 'contact') {
    <div class="custom-header-cta hide-on-mobile style-text-subtle">
      <span>{{ 'Need Help?' | translate: 'website-header.need-help' }}</span>
      <button
        appButton
        name="contact-us"
        location="conversion-template"
        shape="round"
        spacing="3"
        weight="bold"
        (click)="openIntercom()"
      >
        <span>{{ 'Contact Us' | translate: 'website-header.contact-us' }}</span>
      </button>
    </div>
  }
</ng-template>
